import React, { useState, useEffect, useLayoutEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Webhead from './Webhead';
import Webfoot from './Webfoot';
import img1 from './img/img1.jpeg';
import img2 from './img/img2.jpg';
import img3 from './img/img3.jpg';
import img4 from './img/img4.jpg';
import img6 from './img/img6.jpeg';
import Cer from './img/Cer.png';
import Imgq from './img/SS.jpg'
import team1 from './img/team-1.jpg'
import team2 from './img/team-2.jpg'
import team3 from './img/team-3.jpg'
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import LocationOnIcon from "@mui/icons-material/LocationOn";

import './Index.css';
import {
  AppBar, TextField, Typography, Button, Container, Grid, Paper, Avatar, Accordion,
  AccordionSummary,
  AccordionDetails, List, Box,
  ListItem,
  ListItemText, IconButton, Card,
  CardMedia, Divider,
  CardContent
} from '@mui/material';
import Carousel from 'react-material-ui-carousel';
import { styled } from '@mui/material/styles';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import QuoteIcon from '@mui/icons-material/FormatQuote';
import '@fortawesome/fontawesome-free/css/all.min.css';
import {
  School as SchoolIcon,
  BusinessCenter as BusinessCenterIcon,
  TravelExplore as TravelExploreIcon,
  OnlinePrediction as OnlinePredictionIcon,
  People as PeopleIcon,
  ExitToApp as ExitToAppIcon,
} from '@mui/icons-material';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd'; // For Consultant
import TransferWithinAStationIcon from '@mui/icons-material/TransferWithinAStation';
import BookIcon from '@mui/icons-material/Book'; // For Courses
// import australia from '../images/aus7.jpg'
// import canada from '../images/canada.jpg'
// import usa from '../images/usa1.jpg'
// import london from '../images/l3.jpg'
import australia from '../website/img/aus7.jpg'
import canada from '../website/img/canada.jpg'
import usa from '../website/img/usa1.jpg'
import london from '../website/img/l3.jpg'
import { Navigate } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import EngineeringIcon from '@mui/icons-material/Engineering';
import PublicIcon from '@mui/icons-material/Public';


const CustomCard = styled(Card)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.common.white,
  borderRadius: '12px',
  transition: 'transform 0.3s, box-shadow 0.3s',
  '&:hover': {
    transform: 'translateY(-5px)',
    boxShadow: theme.shadows[8],
  },
}));

const IconWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '56px',
  height: '56px',
  borderRadius: '50%',
  backgroundColor: theme.palette.primary.main,
  marginBottom: theme.spacing(2),
}));


const HomePage = () => {

  const navigate = useNavigate();

  const items = [
    {
      img: australia,
      title: "The Best Institute for Online Distance Learning Programs",
    },
    {
      img: canada,
      title: "Experience the Blended Learning",
    },
    {
      img: usa,
      title: "Meet Now Friends And Study With Experts",
    },
    {
      img: london,
      title: "Your International Experience With Us",
    },
  ];

  const facts = [
    {
      title: "Our Vision",
      description: "To create a system that provides learning opportunities for everyone to make a difference in them and in society. ",
      icon: "fa-car",
    },
    {
      title: "Our Mission",
      description: "TII aspires to be an outstanding institute for creative learning and create various academic pathways for our students globally.",
      icon: "fa-users",
    },
    {
      title: "Values",
      description: " Teamwork  , Re-engineer<br />E: Educate<br />N: Nurture T: Trust & True",
      icon: "fa-file-alt",
    },
  ];

  // Custom styled components
  const CustomCard = styled(Card)(({ theme }) => ({
    background: '#b69860',
    color: '#fff',
    borderRadius: '12px',
    transition: 'transform 0.3s, box-shadow 0.3s',
    '&:hover': {
      transform: 'translateY(-5px)',
      boxShadow: theme.shadows[10],
    },
  }));

  const IconWrapper = styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.palette.primary.main,
    borderRadius: '50%',
    width: '60px',
    height: '60px',
    margin: '0 auto 15px auto',
    boxShadow: theme.shadows[2],
  }));



  return (
    <>
      {/* Carousel Start */}
      <Carousel
        autoPlay={true}
        interval={3000}
        navButtonsAlwaysVisible={true}
        indicators={false}
      >
        {items.map((item, i) => (
          <div key={i} style={{ position: 'relative' }}>
            <img
              className="w-100"
              src={item.img}
              alt="Carousel"
              style={{ height: '60vh', objectFit: 'cover' }}
            />
            <div
              style={{
                position: 'absolute',
                bottom: '20%',
                left: '50%',
                transform: 'translateX(-50%)',
                textAlign: 'center',
                color: '#fff',
              }}
            >
              <Typography variant="h2" gutterBottom>
                {item.title}
              </Typography>
              <Button
                variant="contained"
                endIcon={<ExitToAppIcon />}
                sx={{
                  backgroundColor: '#4CAF50', // Change to a custom green color
                  color: 'white',
                  '&:hover': {
                    backgroundColor: '#f6cc57', // Darker shade of green on hover
                  },
                }}
                href="/login"
              >
                Apply Login
              </Button>
              <Button onClick={() => navigate('/Webcourse')} variant="outlined" color="inherit" style={{ marginLeft: '10px' }} >
                View Courses
              </Button>
            </div>
          </div>
        ))}
      </Carousel>
      {/* Carousel End */}

      {/* Facts Start */}
      <Container className="py-5">
        <Grid container spacing={4}>
          {facts.map((fact, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <CustomCard elevation={3}>
                <CardContent>
                  <IconWrapper>
                    <i className={`fa ${fact.icon}`} style={{ fontSize: '1.5rem', color: '#fff' }}></i>
                  </IconWrapper>
                  <Typography variant="h5" gutterBottom align="center">
                    {fact.title}
                  </Typography>
                  <Typography variant="body2" align="center" dangerouslySetInnerHTML={{ __html: fact.description }} />
                  {/* <Button variant="outlined" color="inherit" sx={{ mt: 2, borderRadius: '20px' }}>
                    Learn More
                  </Button> */}
                </CardContent>
              </CustomCard>
            </Grid>
          ))}
        </Grid>
      </Container>
      {/* Facts End */}
    </>
  );
};



const StyleddPaper = styled(Paper)(({ theme }) => ({
  position: 'relative',
  overflow: 'hidden',
  minHeight: '700px',
  borderRadius: '12px',

  transition: 'transform 0.3s',
  '&:hover': {
    transform: 'scale(1.02)', // Slight zoom effect on hover
  },
}));

const StyleddAvatar = styled(Avatar)(({ theme }) => ({
  position: 'absolute',
  top: '16px',
  left: '16px',
  width: '150px',
  height: '150px',
  backgroundColor: theme.palette.primary.main,
  boxShadow: theme.shadows[2],
  border: `4px solid ${theme.palette.background.default}`, // Border around the avatar
}));
const AboutAndCourses = () => {

  const navigate = useNavigate();

  return (
    <>
      {/* About Start */}
      <Container maxWidth="lg" sx={{ py: 6 }}>
        <Grid container spacing={5}>
          <Grid item lg={6}>
            <StyleddPaper>
              <img
                className="position-absolute w-100 h-100"
                src={Cer}
                alt="Cer"
                style={{ objectFit: 'cover', width: '100%', height: '100%', }} // Darken background image for better text readability
              />
              <StyleddAvatar src={img2} alt="Logo" />
            </StyleddPaper>
          </Grid>
          <Grid item lg={6}>
            <Typography variant="h6" color="primary" gutterBottom>
              Newton International College Profile & History
            </Typography>
            <Typography variant="h4" gutterBottom>
              About Newton International College
            </Typography>
            <Typography paragraph>
              Newton International College (TII) was formed with a group of aspiring business enthusiasts, committed to delivering educational services that meet the strategic objectives of our customers and clients. We deliver unmatched educational value to students through a combination of educational process excellence and quality programs of study that provide a sound grounding for exciting and rewarding careers in the ever-changing world economy.
            </Typography>
            <Typography paragraph>
              We operate with corporate values, vision, and mission statements to operate effectively, thus increasing the number of international full-time students in the future. TII is an education consultancy registered in Australia, Singapore, and India, representing several leading UK and France universities. We have also received the ‘Singapore Education Specialist’ certificate for promoting Singapore education in India.
            </Typography>
            <Typography paragraph>
              Currently, we have offices in Sydney, Perth, Singapore, Dhaka, and Chennai. We have a strong focus on recruiting students from developing cities in Singapore, Bangladesh, and India. Currently, we are sending over 300 students annually for local and overseas education, with the majority being for the UK and Europe. Several institutions have applauded our performance across Australia and Singapore.
            </Typography>

            {/* Key Features Section */}
            <Grid container spacing={2} sx={{ mb: 4 }}>
              <Grid item xs={6}>
                <Typography variant="body1">
                  <i className="fa fa-check text-primary me-2"></i>Certificated
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body1">
                  <i className="fa fa-check text-primary me-2"></i>Online Coaching
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body1">
                  <i className="fa fa-check text-primary me-2"></i>Affordable Fees
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body1">
                  <i className="fa fa-check text-primary me-2"></i>Best Trainers
                </Typography>
              </Grid>
            </Grid>

            {/* Contact Button Section */}
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Button
                  variant="outlined"
                  color="primary"
                  fullWidth
                  href="tel:+0123456789"
                  startIcon={<i className="fa fa-phone-alt"></i>}
                  sx={{
                    borderRadius: '8px',
                    padding: '10px 0',
                    fontWeight: 'bold',
                    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)', // Subtle shadow
                    borderWidth: '2px',
                    '&:hover': {
                      backgroundColor: '#f5f5f5', // Light background on hover
                    },
                  }}
                >
                  Tel: +65 6332 7878
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
      {/* About End */}

      {/* Courses Start */}
      <Container maxWidth="xlg" sx={{ my: 6, py: 6 }}>
        <Typography variant="h4" color="primary" fontWeight={600} textAlign="center" gutterBottom>
          Explore Our Popular Online Courses
        </Typography>
        <Typography variant="h4" textAlign="center" fontWeight={600} gutterBottom>
          Our Courses
        </Typography>
        <Grid container spacing={4} justifyContent="center">
          {/* Course 1 */}
          <Grid item lg={4} md={6}>
            <Paper elevation={3} sx={{ p: 2 }}>
              <Typography variant="h5" fontWeight={600} color="primary" textAlign="center" gutterBottom>
                BBA
              </Typography>
              <Typography variant="h6" gutterBottom>
                Bachelor of Business Administration
              </Typography>
              <Typography paragraph>
                BBA is a terminal degree. A Bachelor of Business Administration (BBA)
                degree is a course that mostly deals with business administration and
                management.
              </Typography>
              <Grid container spacing={1} justifyContent="center">
                <Grid item>
                  <Typography variant="body2">
                    <i className="fa fa-signal text-primary me-2"></i>Full-Time Course
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography variant="body2">
                    <i className="fa fa-calendar-alt text-primary me-2"></i>52 Weeks
                  </Typography>
                </Grid>
              </Grid>
              <img className="img-fluid" src={img3} alt="img3" />
              <Button  onClick={() => navigate('/Webcourse')} variant="outlined" color="primary" sx={{ mt: 2 }}>
                Read More
              </Button>
            </Paper>
          </Grid>
          {/* Course 2 */}
          <Grid item lg={4} md={6}>
            <Paper elevation={3} sx={{ p: 2 }}>
              <Typography variant="h5" fontWeight={600} textAlign="center" color="primary" gutterBottom>
                MBA
              </Typography>
              <Typography variant="h6" gutterBottom>
                Master of Business Administration
              </Typography>
              <Typography paragraph>
                A Master of Business Administration, or MBA degree, is a
                graduate-level business and management degree with a focus on
                leadership and managerial skills.
              </Typography>
              <Grid container spacing={1} justifyContent="center">
                <Grid item>
                  <Typography variant="body2">
                    <i className="fa fa-signal text-primary me-2"></i>Post Graduate
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography variant="body2">
                    <i className="fa fa-calendar-alt text-primary me-2"></i>52 Weeks
                  </Typography>
                </Grid>
              </Grid>
              <img className="img-fluid" src={img4} alt="img4" />
              <Button   onClick={() => navigate('/Webcourse')} variant="outlined" color="primary" sx={{ mt: 2 }}>
                Read More
              </Button>
            </Paper>
          </Grid>
          {/* Contact Us Section */}
          {/* Contact Us Section */}

          {/* <Grid item xs={12} md={8}>
            <Paper
              elevation={3}
              sx={{
                p: 5,
                backgroundColor: '#FCD018',
                textAlign: 'center',
                borderRadius: 2,
              }}
            ><Typography
              variant="h4"
              fontWeight={600}
              gutterBottom
              sx={{ color: '#fff', textAlign: 'center', mb: 4 }}
            >
                Contact Us
              </Typography>
              <form >
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      label="Your Name"
                      required
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      label="Your Email"
                      type="email"
                      required
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      label="Your Mobile"
                      required
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      label="Your Course"
                      required
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      label="Message"
                      multiline
                      rows={4}
                      required
                    />
                  </Grid>

                  <Grid item xs={12} sm={4} sx={{ mx: 'auto', mt: 2 }}>
                    <Button
                      variant="contained"
                      color="secondary"
                      fullWidth
                      type="submit"
                      sx={{ fontWeight: 'bold', py: 1.5 }}
                    >
                      Send Message
                    </Button>
                  </Grid>
                </Grid>
              </form>
            </Paper>
          </Grid> */}

        </Grid>
      </Container>
      {/* Courses End */}
    </>
  );
};



const ServicesAndFeatures = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const handleAccordionChange = (index) => (event, isExpanded) => {
    setActiveIndex(isExpanded ? index : null);
  };

  const services = [
    {
      title: 'Consultant',
      description: 'Education Consultant to individuals and Organizations',
      icon: <AssignmentIndIcon />,
    },
    {
      title: 'Migration',
      description: 'Migration services (student visa and resident) to Australia, Canada, USA and Europe',
      icon: <TransferWithinAStationIcon />,
    },
    {
      title: 'Management',
      description: 'Management Training Programmes, Education Tour packages',
      icon: <SchoolIcon />,
    },
    {
      title: 'Courses',
      description: 'Online/Distance learning Programmes from international universities',
      icon: <BookIcon />,
    },
  ];

  const accordionItems = [
    {
      title: 'English Courses',
      content: [
        'IELTS (International English Language Test System) Intensive preparation (Academic/Immigration purpose)',
        'Pearson Test English (PTE) training (Academic/Immigration purpose)',
        'General English',
      ],
    },
    {
      title: 'Trans Disciplinary Studies (Certificate Level)',
      content: [
        'Transformative learning',
        'Re-Balancing of ECO-System',
        'Transformative wellness',
        'Professional Prosperity',
        'Sustainable practice in day-to-day life',
        'Personal and Professional Development',
      ],
    },
    {
      title: 'Vocational Courses (Certificate Level)',
      content: [
        'International Trade',
        'Leadership and Management',
        'Marketing and Communication',
        'Early Childhood Education and Care',
        'PLC system',
        'CAD/CAM',
        'Microsoft project',
      ],
    },
    {
      title: 'Diploma Courses Distance Learning Programmes',
      content: [
        'Civil Engineering',
        'Mechanical Engineering',
        'Electrical Engineering',
        'Facilities Management',
        'Building M&E service',
      ],
    },
    {
      title: 'Degree Courses Distance Learning Programmes',
      content: [
        'Civil Engineering',
        'Business',
        'Mechanical Engineering',
        'Electrical Engineering',
      ],
    },
  ];

  return (
    <Container maxWidth="xl" sx={{ py: 6 }}>
      <Grid container spacing={5}>
        <Grid item lg={6}>
          <Typography variant="h5" color="primary" fontWeight={600} gutterBottom>
            Why Choose Us!
          </Typography>
          <Typography variant="h4" fontWeight={600} gutterBottom>
            Our Services
          </Typography>
          <Typography paragraph>
            Newton International College (TII) is established to bring education to your
            doorstep and enhance your profile with personnel and professional development.
          </Typography>
          <Grid container spacing={4}>
            {services.map((item, index) => (
              <Grid item xs={12} sm={6} key={index}>
                <Paper
                  elevation={3}
                  sx={{
                    p: 3,
                    display: 'flex',
                    alignItems: 'center',
                    height: '150px', // Fixed height for all cards
                    transition: 'transform 0.3s',
                    '&:hover': {
                      transform: 'scale(1.05)', // Scale on hover
                    },
                  }}
                >
                  <Box
                    sx={{
                      bgcolor: 'primary.main',
                      color: 'white',
                      p: 2,
                      borderRadius: '50%',
                      mr: 2,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: 56,
                      height: 56,
                    }}
                  >
                    {item.icon}
                  </Box>
                  <Box>
                    <Typography variant="h6" fontWeight={600}>
                      {item.title}
                    </Typography>
                    <Typography variant="body2">{item.description}</Typography>
                  </Box>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Grid>
        <Grid item lg={6}>
          <Box sx={{ position: 'relative', overflow: 'hidden', height: '400px' }}>
            <img
              src={img6}
              alt="Main visual"
              style={{ position: 'absolute', width: '100%', height: '100%', objectFit: 'cover' }}
            />
            <img
              src={img1}
              alt="Overlay visual"
              style={{ position: 'absolute', top: 0, right: 0, width: '200px', height: '200px' }}
            />
          </Box>
        </Grid>
      </Grid>

      <Typography
        variant="h4"
        sx={{
          my: 4,
          color: '#F9A825',
          fontWeight: 700,
          textAlign: 'center',
        }}
      >
        Educational Programs Offered
      </Typography>
      <Box
        sx={{
          backgroundImage: `url(${Imgq})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          py: 8,
          px: 4,
        }}
      >
        {accordionItems.map((item, index) => (
          <Accordion key={index} expanded={activeIndex === index} onChange={handleAccordionChange(index)}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ bgcolor: '#ffce2f', color: '#000000' }}>
              <Typography variant="h6">{item.title}</Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ bgcolor: '#f9f9f9' }}>
              <List>
                {item.content.map((text, idx) => (
                  <ListItem key={idx}>
                    <ListItemText primary={text} />
                  </ListItem>
                ))}
              </List>
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>
    </Container>
  );
};

const TeamCard = styled(Card)(({ theme }) => ({
  position: 'relative',
  '&:hover': {
    boxShadow: theme.shadows[8],
  },
}));

const TeamSection = () => {
  const teamMembers = [
    {
      name: 'Sai Krishnan',
      position: 'Trainer',
      image: img1, // Use imported image
      social: {
        facebook: '#',
        twitter: '#',
        instagram: '#',
      },
    },
    {
      name: 'Marry John',
      position: 'Assistant Professor',
      image: img2, // Use imported image
      social: {
        facebook: '#',
        twitter: '#',
        instagram: '#',
      },
    },
    {
      name: 'Lucas Jack',
      position: 'Trainer',
      image: img3, // Use imported image
      social: {
        facebook: '#',
        twitter: '#',
        instagram: '#',
      },
    },
    {
      name: 'David Bruce',
      position: 'Trainer',
      image: img4, // Use imported image
      social: {
        facebook: '#',
        twitter: '#',
        instagram: '#',
      },
    },
  ];

  const locations = [
    {
      city: "Perth",
      address: "17 128 Brown Street, East Perth, WA (Western Australia), 6004 Australia.",
      phone: "+61 423632306",
    },
    {
      city: "Sydney",
      address: "479, Great Western Highway, Greystanes, 2147",
      phone: "+61 470249149",
    },
    {
      city: "Singapore Branch",
      address: "89 Short Street, #09-08B, Golden Wall Center, Singapore – 188216",
      phone: "+65 86006494",
    },
    {
      city: "India Branch",
      address: "749, 3rd Floor, TSJ Complex, Anna Statue Signal, Avinashi Road, Coimbatore – 641018",
      phone: "+91 89739 87737",
    },
  ];
  return (
    <Container sx={{ py: 6 }}>
        {/* <Typography
            variant="h5"
            fontWeight={600}
            gutterBottom
            sx={{ color: "#F9A825", mb: 3 }} // Yellow Subheading
          >
            Our Locations
          </Typography> */}
          

    {/* Horizontal Card Layout */}
    {/* <Grid container spacing={3} justifyContent="space-between">
            {locations.map((location, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <Card
                  sx={{
                    boxShadow: 3,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    height: "100%",
                  }}
                >
                  <CardContent>
                    <Typography variant="h6" fontWeight={600} gutterBottom>
                      {location.city}
                    </Typography>
                    <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                      <LocationOnIcon sx={{ mr: 1, color: "primary.main" }} />
                      <Typography variant="body2" color="textSecondary">
                        {location.address}
                      </Typography>
                    </Box>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <PhoneIcon sx={{ mr: 1, color: "primary.main" }} />
                      <Typography variant="body2" color="textSecondary">
                        {location.phone}
                      </Typography>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid> */}
    </Container>
  );
};


const WelcomeSection = () => {
  return (
    <Box sx={{ py: 8 }}>
      {/* Welcome Section */}
      <Box sx={{ textAlign: 'center', mb: 6 }}>
        <Typography variant="h3" fontWeight={700} gutterBottom sx={{ color: '#F9A825' }}>
          Welcome to Newton International College
        </Typography>
        <Typography variant="h6" color="textSecondary">
          Follow Us To Join Our Events
        </Typography>
      </Box>

      {/* Courses Section */}
      <Grid container spacing={4} justifyContent="center">
        {/* English & Design Courses */}
        <Grid item xs={12} sm={6} lg={3}> {/* Adjust the column widths */}
          <Paper
            elevation={6}
            sx={{
              p: 3,
              textAlign: 'center',
              borderRadius: 4,
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              backgroundColor: '#ffffff',
              transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
              '&:hover': { transform: 'scale(1.05)', boxShadow: '0 6px 18px rgba(0, 0, 0, 0.1)' },
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <SchoolIcon sx={{ fontSize: 48, color: '#F9A825', mr: 2 }} />
              <Typography variant="h5" fontWeight={600} gutterBottom sx={{ color: '#F9A825' }}>
                English & Design Courses
              </Typography>
            </Box>
            <Divider sx={{ backgroundColor: '#F9A825', my: 2 }} />
            <Typography variant="body1" color="textSecondary" sx={{ mb: 3 }}>
              Enroll for the right course & learn from our professional teachers who hold internationally recognized qualifications in teaching English.
            </Typography>
            {/* <Button variant="contained" sx={{ backgroundColor: '#F9A825', color: '#fff' }}>
              Enroll Now
            </Button> */}
          </Paper>
        </Grid>

        {/* Engineering Courses */}
        <Grid item xs={12} sm={6} lg={3}>
          <Paper
            elevation={6}
            sx={{
              p: 3,
              textAlign: 'center',
              borderRadius: 4,
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              backgroundColor: '#ffffff',
              transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
              '&:hover': { transform: 'scale(1.05)', boxShadow: '0 6px 18px rgba(0, 0, 0, 0.1)' },
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <EngineeringIcon sx={{ fontSize: 48, color: '#F9A825', mr: 2 }} />
              <Typography variant="h5" fontWeight={600} gutterBottom sx={{ color: '#F9A825' }}>
                Engineering Courses
              </Typography>
            </Box>
            <Divider sx={{ backgroundColor: '#F9A825', my: 2 }} />
            <Typography variant="body1" color="textSecondary" sx={{ mb: 3 }}>
            In Engineering Courses, Learn engineering with today's advanced technologies, including mobile apps, online courses, and simulations at Newton International College.
            </Typography>
            {/* <Button variant="contained" sx={{ backgroundColor: '#F9A825', color: '#fff' }}>
              Learn More
            </Button> */}
          </Paper>
        </Grid>

        {/* Study Abroad */}
        <Grid item xs={12} sm={6} lg={3}>
          <Paper
            elevation={6}
            sx={{
              p: 3,
              textAlign: 'center',
              borderRadius: 4,
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              backgroundColor: '#ffffff',
              transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
              '&:hover': { transform: 'scale(1.05)', boxShadow: '0 6px 18px rgba(0, 0, 0, 0.1)' },
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <PublicIcon sx={{ fontSize: 48, color: '#F9A825', mr: 2 }} />
              <Typography variant="h5" fontWeight={600} gutterBottom sx={{ color: '#F9A825' }}>
                Study Abroad
              </Typography>
            </Box>
            <Divider sx={{ backgroundColor: '#F9A825', my: 2 }} />
            <Typography variant="body1" color="textSecondary" sx={{ mb: 3 }}>
              Get expert advice and information on colleges, courses, exams, admission, student visas, and the application process to study overseas.
            </Typography>
            {/* <Button variant="contained" sx={{ backgroundColor: '#F9A825', color: '#fff' }}>
              Get Advice
            </Button> */}
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};




const services = [
  {
    title: 'Education Consultancy',
    icon: <SchoolIcon fontSize="large" />,
    description: 'Consulting services for individuals and organizations to improve educational outcomes.',
  },
  {
    title: 'University Representation',
    icon: <PeopleIcon fontSize="large" />,
    description: 'Representation of reputable universities from Australia, UK, USA, and Europe.',
  },
  {
    title: 'Management Training',
    icon: <BusinessCenterIcon fontSize="large" />,
    description: 'Tailored management training programmes and education tour packages.',
  },
  {
    title: 'Online Learning',
    icon: <OnlinePredictionIcon fontSize="large" />,
    description: 'Access to online/distance learning programmes from international universities.',
  },
  {
    title: 'European Global School Partner',
    icon: <TravelExploreIcon fontSize="large" />,
    description: 'Official partner to the European Global School, France.',
  },
  {
    title: 'Migration Services',
    icon: <ExitToAppIcon fontSize="large" />,
    description: 'Student visa and residency services to Australia, Canada, USA, and Europe.',
  },
];

const OurProductsAndServices = () => {
  return (
    <Container sx={{ my: 8 }}>
      <Typography variant="h3" component="h4" sx={{ mb: 4, textAlign: 'center', fontWeight: 'bold' }}>
        Our Products and Services
      </Typography>
      <Typography variant="body1" sx={{ mb: 4, textAlign: 'center', fontSize: '1.1rem', color: 'black' }}>
        Newton International College (TII) is established to bring education to your doorstep and enhance your profile with personnel and professional development.
      </Typography>
      <Grid container spacing={4}>
        {services.map((service, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card
              sx={{
                height: '100%', // Ensures all cards are the same height
                backgroundColor: '#FCD018', // Set the background color
                color: 'black', // Set text color for contrast
                boxShadow: 3,
                textAlign: 'center',
                borderRadius: 2,
                transition: 'transform 0.3s', // Smooth transition for hover effect
                '&:hover': {
                  transform: 'scale(1.05)', // Scale effect on hover
                  boxShadow: 6, // Increased shadow on hover
                },
              }}>
              <CardContent sx={{ padding: 4 }}>
                <Box sx={{ mb: 2 }}>
                  {service.icon}
                </Box>
                <Typography variant="h6" component="h3" sx={{ fontWeight: 'bold', mb: 1 }}>
                  {service.title}
                </Typography>
                <Divider sx={{ mb: 2 }} />
                <Typography variant="body2" color="textSecondary">
                  {service.description}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

// Styled component for Testimonials
const Testimonials = styled(Card)(({ theme }) => ({
  position: 'relative',
  textAlign: 'center',
  padding: theme.spacing(4),
  boxShadow: theme.shadows[3],
  margin: theme.spacing(2),
}));

const testimonials = [
  {
    name: 'Jacob',
    position: 'Engineer',
    image: team1, // Use the imported image here
    quote:
      "I'm so glad I chose Newton International College for my studies. The courses are well-structured, the professors are highly experienced, and the campus facilities are excellent. It's been a rewarding experience!",
  },
  {
    name: 'Manoj',
    position: 'Engineer',
    image: team2, // Use the imported image here
    quote:
      "Newton International College exceeded my expectations. From the engaging lectures to the practical training opportunities, every aspect of my education here has been enriching. I feel confident about my future thanks to Newton!",
  },
  {
    name: 'Mithali',
    position: 'Professor',
    image: team3, // Use the imported image here
    quote:
      'My time at Newton International College has been transformative. The personalized attention from professors, combined with the modern learning resources, has made my academic journey truly fulfilling.',
  },
];

const TestimonialSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
  };

  const handlePrevious = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <Container maxWidth='' sx={{ py: 6 }}>
      <Box textAlign="center" mb={5}>
        <Typography variant="h2" color="primary" gutterBottom>
          Testimonials
        </Typography>
        <Typography variant="h5" component="h1" gutterBottom>
          What Our Clients Say!
        </Typography>
      </Box>

      <Grid container justifyContent="center">
        <Grid item xs={12} md={8}>
          <Testimonials>
            <Box position="relative" mb={5}>
              <CardMedia
                component="img" // Correct this from "image" to "img"
                image={testimonials[currentIndex].image}
                alt={testimonials[currentIndex].name}
                sx={{
                  borderRadius: '50%',
                  width: '120px',
                  height: '120px',
                  margin: '0 auto',
                }}
              />
              <Box
                position="absolute"
                top="100%"
                left="50%"
                sx={{
                  transform: 'translate(-50%, -50%)',
                  bgcolor: 'white',
                  borderRadius: '50%',
                  width: '60px',
                  height: '60px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow: 3,
                }}
              >
                <QuoteIcon color="primary" fontSize="large" />
              </Box>
            </Box>
            <Typography variant="body1" sx={{ fontStyle: 'italic' }}>
              {testimonials[currentIndex].quote}
            </Typography>
            <hr style={{ width: '25%', margin: '20px auto' }} />
            <Typography variant="h6">{testimonials[currentIndex].name}</Typography>
            <Typography variant="body2" color="textSecondary">
              {testimonials[currentIndex].position}
            </Typography>

            {/* Navigation Buttons */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', marginTop: 2 }}>
              <Button variant="outlined" onClick={handlePrevious}>
                Previous
              </Button>
              <Button variant="outlined" onClick={handleNext}>
                Next
              </Button>
            </Box>
          </Testimonials>
        </Grid>
      </Grid>
    </Container>
  );
};

const Adhome = () => {

  return (
    <div >
      <Webhead />

      <div >

        < HomePage />
        <AboutAndCourses />
        <WelcomeSection />
        <ServicesAndFeatures />
       
        <OurProductsAndServices />
       
        <TeamSection />
        
        {/* <TestimonialSection /> */}
        <Webfoot />
      </div>
    </div>
  );
};




export default Adhome;  